import React, { useState, useEffect } from 'react';
import { Button, Form, Card, Alert, Container, Row, Col } from 'react-bootstrap';
import { Lock, User, AlertTriangle } from 'lucide-react';
import useAuth from '../../hooks/useAuth';
import useForm from '../../hooks/useForm';

const Login = () => {
    const { login } = useAuth();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [sessionMessage, setSessionMessage] = useState('');

    const { values, handleChange } = useForm({
        username: '',
        password: ''
    });

    // Vérifier s'il y a un message de session au chargement du composant
    useEffect(() => {
        const message = localStorage.getItem('sessionMessage');
        if (message) {
            setSessionMessage(message);
            // Nettoyer le message après l'avoir lu
            localStorage.removeItem('sessionMessage');

            // Optionnel : faire disparaître le message après 8 secondes
            setTimeout(() => {
                setSessionMessage('');
            }, 8000);
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        // Nettoyer le message de session lors d'une nouvelle tentative de connexion
        setSessionMessage('');

        try {
            const result = await login(values.username, values.password);

            if (!result.success) {
                setError(result.message);
            }
        } catch (err) {
            setError('Une erreur inattendue s\'est produite. Veuillez réessayer.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
            <Card className="shadow-sm" style={{ width: '100%', maxWidth: '400px' }}>
                <Card.Body className="p-4">
                    <div className="text-center mb-4">
                        <h2 className="mb-3">SEN OSCAR</h2>
                        <p className="text-muted">CONNEXION</p>
                    </div>

                    {/* Affichage du message de session expirée */}
                    {sessionMessage && (
                        <Alert variant="warning" className="d-flex align-items-center mb-3">
                            <AlertTriangle size={18} className="me-2" />
                            <span>{sessionMessage}</span>
                        </Alert>
                    )}

                    {error && <Alert variant="danger">{error}</Alert>}

                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>Nom d'utilisateur</Form.Label>
                            <div className="input-group">
                                <span className="input-group-text">
                                    <User size={18} />
                                </span>
                                <Form.Control
                                    type="text"
                                    name="username"
                                    value={values.username}
                                    onChange={handleChange}
                                    placeholder="Entrer votre nom d'utilisateur"
                                    required
                                />
                            </div>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label>Mot de passe</Form.Label>
                            <div className="input-group">
                                <span className="input-group-text">
                                    <Lock size={18} />
                                </span>
                                <Form.Control
                                    type="password"
                                    name="password"
                                    value={values.password}
                                    onChange={handleChange}
                                    placeholder="Entrer votre mot de passe"
                                    required
                                />
                            </div>
                        </Form.Group>

                        <Button
                            variant="primary"
                            type="submit"
                            className="w-100"
                            disabled={loading}
                        >
                            {loading ? 'En cours de connexion...' : 'Se connecter'}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default Login;